var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"global-window venda-sel"},[_c('div',{staticClass:"global-closebutton",on:{"click":function($event){return _vm.fechaJanela()}}},[_vm._v(" X ")]),_c('FormaPagamento'),(_vm.opt_mercado == 'true')?_c('VendaMercado'):_vm._e(),_c('ResumoVenda')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }